import { cn } from '@linka/utils';

const Table = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableElement> & { ref?: React.Ref<HTMLTableElement> }) => (
  <div className='overflow-x-auto rounded-ss-md rounded-se-md bg-base-neutral-white'>
    <div className='min-w-full'>
      <div className='relative w-full overflow-auto'>
        <table ref={ref} className={cn('w-full caption-bottom text-xs', className)} {...props} />
      </div>
    </div>
  </div>
);

const TableHeader = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement> & { ref?: React.Ref<HTMLTableSectionElement> }) => (
  <thead
    ref={ref}
    className={cn('[&_tr]:border-b border-ctx-layout-border bg-ctx-layout-body', className)}
    {...props}
  />
);

const TableBody = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement> & { ref?: React.Ref<HTMLTableSectionElement> }) => (
  <tbody
    ref={ref}
    className={cn('[&_tr:last-child]:border-0 border-ctx-layout-border bg-base-neutral-white', className)}
    {...props}
  />
);

const TableFooter = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement> & { ref?: React.Ref<HTMLTableSectionElement> }) => (
  <tfoot ref={ref} className={cn('bg-ctx-layout-surface w-full block p-mini', className)} {...props} />
);

const TableRow = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement> & { ref?: React.Ref<HTMLTableRowElement> }) => (
  <tr ref={ref} className={cn('even:bg-ctx-layout-body', className)} {...props} />
);

const TableHead = ({
  className,
  ref,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement> & { ref?: React.Ref<HTMLTableCellElement> }) => (
  <th
    ref={ref}
    className={cn(
      'border-b border-ctx-layout-border py-micro px-xxs text-left text-ctx-content-title ts-heading-xxs whitespace-nowrap [&:has([role=checkbox])]:pr-0',
      className,
    )}
    {...props}
  />
);

const TableCell = ({
  className,
  ref,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement> & { ref?: React.Ref<HTMLTableCellElement> }) => (
  <td
    ref={ref}
    className={cn(
      'ts-paragraph-xxs text-ctx-content-base h-[70px] py-mini px-xxs whitespace-nowrap [&:has([role=checkbox])]:pr-0',
      className,
    )}
    {...props}
  />
);

const TableCaption = ({
  className,
  ref,
  ...props
}: React.HTMLAttributes<HTMLTableCaptionElement> & { ref?: React.Ref<HTMLTableCaptionElement> }) => (
  <caption ref={ref} className={cn('mt-4 text-xs text-ctx-content-title/semiOpaque', className)} {...props} />
);

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
